<template>
  <header class="navy" :class="{fixedHeader: tempIsFixedHeader || !isHome}">
    <nav>
      <div class="logo">
        <a href="#" v-if="isHome" v-scroll-to="{el : 'html'}">
          <img src="@/assets/img/giupnuri_logo.png" v-if="tempIsFixedHeader || !isHome"  alt=""/>
          <img src="@/assets/img/giupnuri_logo_white.png" alt="" v-else />
        </a>
        <a href="/" v-else>
          <img src="@/assets/img/giupnuri_logo.png" v-if="tempIsFixedHeader || !isHome"  alt=""/>
          <img src="@/assets/img/giupnuri_logo_white.png" alt="" v-else />
        </a>
        <!--Menu-->
        <div class="menu" v-show="isHome">
          <ul>
            <li>
              <a href="#" v-scroll-to="{el : '#introduce', offset: -71}">제품소개</a>
            </li>
            <li>
              <a href="#" v-scroll-to="{el: '#customer', offset: -71}">고객사례</a>
            </li>
            <li>
              <a href="#" v-scroll-to="{el: '#inquire', offset: -71}">도입문의</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="sign">
        <ul v-if="!$Util.isEmpty(userData)">
          <li v-show="userData.isElect === 1" :class="{on: $route.path.startsWith('/elect')}">
            <a href="#" @click.prevent="$router.push('/elect/report')">전력비 절감</a>
          </li>
          <li v-show="userData.isCert === 1" :class="{on: $route.path.startsWith('/cert')}">
            <a href="#" @click.prevent="$router.push('/cert')">인증</a>
          </li>
<!--          <li v-show="userData.isLab === 1">-->
<!--            <a href="#" @click.prevent="move">연구소</a>-->
<!--          </li>-->
<!--          <li class="seperate">-->
<!--            <div></div>-->
<!--          </li>-->
<!--          <li>-->
<!--            <a href="#" @click.prevent="">노무, 인증</a>-->
<!--          </li>-->
<!--          <li class="seperate">-->
<!--            <div></div>-->
<!--          </li>-->
<!--          <li>-->
<!--            <a href="#" @click.prevent="">연구소 관리</a>-->
<!--          </li>-->
          <li>
            <a href="#" @click.prevent="doLogout">로그아웃</a>
          </li>
        </ul>
        <ul v-else>
          <li>
            <a href="#" @click.prevent="$router.push('/account/sign')">
              회원가입
            </a>
          </li>
          <li>
            <a href="#" @click.prevent="$router.push('/account/login')">
              로그인
            </a>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>
<script>
export default {
  name: 'layout-header',
  props: {
    isFixedHeader: {
      type: Boolean,
      default: false
    },
    isHome: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      tempIsFixedHeader: this.isFixedHeader
    }
  },
  computed: {
    userData: function () {
      return this.$store.getters['account/getUserData']
    },
  },
  mounted: function () {
    const _this = this
    window.addEventListener('scroll', () => {
      _this.tempIsFixedHeader = window.scrollY > 50;
    })
  },
  methods: {
    doLogout: async function () {
      if (!confirm("로그아웃 하시겠습니까?")) {
        return false
      }

      this.$store.commit('account/storeLogout')
      alert('로그아웃 되었습니다.')

      this.$router.go(0)
    },
    move: function () {
      alert('준비중입니다.')
    }
  }
}
</script>
<style lang="scss" scoped>
.logo img {
  height: 100%;
  vertical-align: top;
}

.fixedHeader {
  position: fixed !important;
  background-color: white;
  border-bottom: #EEEEEE solid 1px;
  z-index: 51 !important;
  height: 70px;
}

.fixedHeader:after {
  content: "";
  display: block;
}

.fixedHeader > nav {
  padding-top: 0 !important;
}

.fixedHeader > nav, .fixedHeader > nav .menu {
  color: #333333 !important;
}

.navy, .menu {
  color: white !important;
}
.seperate {
  div {
    border-right: #b6b6b6 solid 1px !important;
    width: 2px;
    height: 10px;
  }
}

.sign {
  li a:hover, li.on a {
    font-size: 1.1rem;
    font-weight: bold;
  }
}
</style>
